module.exports = __webpack_public_path__ + "src/assets/img/ramblerhoroscopes.f911afb1.jpg";